import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RenameDeviceSignalTagDocument } from './rename.generated';

export const useRenameDeviceSignalTag = (
  options: ApiOptions<typeof RenameDeviceSignalTagDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(RenameDeviceSignalTagDocument, {
    ...useNotifications(RenameDeviceSignalTagDocument, {
      failure: t('api.device_signal_tags.rename_error'),
      success: t('api.device_signal_tags.rename_success'),
    }),
    ...options,
  });
};
